module.exports = __webpack_public_path__ + "static/media/checkbox2team.d6f49db4.svg";